module.exports = __webpack_public_path__ + "static/firstaveLogo-5eaa63e31d624ea909dbed49ecb7ca57.png";